import { castArray } from "lodash-es";

export function valueToArray<T>(value: readonly T[] | T | null | undefined): readonly T[] {
  if (value == null) return [];
  return castArray(value) as readonly T[];
}
